import { Route } from "@angular/router";
import { Page404Component } from "app/authentication/page404/page404.component";
import { JourneyComponent } from "./journey/journey.component";
import { DailyScheduleComponent } from "./daily-schedule/daily-schedule.component";
import { JourneyDetailComponent } from "./journey/journey-detail.component";
import { DailyScheduleDetailComponent } from "./daily-schedule/daily-schedule-detail.component";
import { WorkCycleComponent } from "./work-cycle/work-cycle.component";
import { WorkCycleDetailComponent } from "./work-cycle/work-cycle-detail.component";
import { ZoneComponent } from "./zone/zone.component";
import { ZoneDetailComponent } from "./zone/zone-detail.component";
import { AttendanceEventComponent } from "./attendance-event/attendance-event.component";
import { AttendanceEventDetailComponent } from "./attendance-event/attendance-event-detail.component";
import { FacialEvidenceComponent } from "./facial-evidence/facial-evidence.component";
import { AttendanceAttemptComponent } from "./attendance-attempt/attendance-attempt.component";
import { AttendanceAttemptDetailComponent } from "./attendance-attempt/attendance-attempt-detail.component";
import { TrackingPointComponent } from "./tracking-point/tracking-point.component";
import { TrackingPointDetailComponent } from "./tracking-point/tracking-point-detail.component";
import { WorkCalendarComponent } from "./work-calendar/work-calendar.component";
import { RestConfigurationComponent } from "./rest-configuration/rest-configuration.component";
import { RestConfigurationDetailComponent } from "./rest-configuration/rest-configuration-detail.component";
import { WorkCenterComponent } from "./work-center/work-center.component";
import { WorkCenterDetailComponent } from "./work-center/work-center-detail.component";
import { MobileLogComponent } from "./mobile-log/mobile-log.component";
import { MobileLogDetailComponent } from "./mobile-log/mobile-log-detail.component";
import { SystemLogComponent } from "./system-log/system-log.component";
import { SystemLogDetailComponent } from "./system-log/system-log-detail.component";
import { OvertimeComponent } from "./overtime/overtime.component";
import { OvertimeDetailComponent } from "./overtime/overtime-detail.component";
import { AttendanceResultComponent } from "./attendance-result/attendance-result.component";
import { AttendanceResultDetailComponent } from "./attendance-result/attendance-result-detail.component";
import { AttendanceJustificationTypeComponent } from "./attendance-justification-type/attendance-justification-type.component";
import { AttendanceJustificationTypeDetailComponent } from "./attendance-justification-type/attendance-justification-type-detail.component";
import { AttendanceJustificationComponent } from "./attendance-justification/attendance-justification.component";
import { AttendanceJustificationDetailComponent } from "./attendance-justification/attendance-justification-detail.component";
import { AbsenceComponent } from "./absence/absence.component";
import { DelayComponent } from "./delay/delay.component";
import { EarlyExitComponent } from "./early-exit/early-exit.component";
import { MissingPunchComponent } from "./missing-punch/missing-punch.component";
import { WebPunchComponent } from "./web-punch/web-punch.component";
import { MODULE_RESOURCES, moduleAccess } from "@core/config/module-access";


export const ATTENDANCE_ROUTE: Route[] = [
    {
        path: "punch",
        component: WebPunchComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.WEB-PUNCH',
                icon: 'touch_app',
                order: 1,
            },
            auth: {
                anyOf: [
                    { resource: 'attendance-events', action: 'create-self' },
                    { resource: MODULE_RESOURCES.attendance.event, action: 'create-self' },
                ],
            },
        },
    },
    {
        path: "journey",
        redirectTo: "journeys",
        pathMatch: "full",
    },
    {
        path: "daily-schedule",
        redirectTo: "daily-schedules",
        pathMatch: "full",
    },
    {
        path: "work-cycle",
        redirectTo: "work-cycles",
        pathMatch: "full",
    },
    {
        path: "zone",
        redirectTo: "zones",
        pathMatch: "full",
    },
    {
        path: "rest-configuration",
        redirectTo: "rest-configurations",
        pathMatch: "full",
    },
    {
        path: "work-center",
        redirectTo: "work-centers",
        pathMatch: "full",
    },
    {
        path: "mobile-log",
        redirectTo: "mobile-logs",
        pathMatch: "full",
    },
    {
        path: "system-log",
        redirectTo: "system-logs",
        pathMatch: "full",
    },
    {
        path: "overtime",
        redirectTo: "overtimes",
        pathMatch: "full",
    },
    {
        path: "attendance-event",
        redirectTo: "attendance-events",
        pathMatch: "full",
    },
    {
        path: "attendance-attempt",
        redirectTo: "attendance-attempts",
        pathMatch: "full",
    },
    {
        path: "attendance-result",
        redirectTo: "attendance-results",
        pathMatch: "full",
    },
    {
        path: "attendance-justification-type",
        redirectTo: "attendance-justification-types",
        pathMatch: "full",
    },
    {
        path: "attendance-justification",
        redirectTo: "attendance-justifications",
        pathMatch: "full",
    },
    {
        path: "tracking-point",
        redirectTo: "tracking-points",
        pathMatch: "full",
    },
    {
        path: "work-calendar",
        component: WorkCalendarComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.WORK-CALENDAR',
                order: 15,
            },
            auth: moduleAccess(MODULE_RESOURCES.client.organization.employees),
        },
    },
    {
        path: "journeys/new",
        component: JourneyDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.journey),
        },
    },
    {
        path: "journeys/:journeyId/edit",
        component: JourneyDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.journey),
        },
    },
    {
        path: "journeys/:journeyId",
        component: JourneyDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.journey),
        },
    },
    {
        path: "journeys",
        component: JourneyComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.JOURNEY',
                order: 2,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.journey),
        },
    },
    {
        path: "daily-schedules/new",
        component: DailyScheduleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.dailySchedule),
        },
    },
    {
        path: "daily-schedules/:dailyScheduleId/edit",
        component: DailyScheduleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.dailySchedule),
        },
    },
    {
        path: "daily-schedules/:dailyScheduleId",
        component: DailyScheduleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.dailySchedule),
        },
    },
    {
        path: "daily-schedules",
        component: DailyScheduleComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.DAILY-SCHEDULE',
                order: 3,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.dailySchedule),
        },
    },
    {
        path: "work-cycles/new",
        component: WorkCycleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCycle),
        },
    },
    {
        path: "work-cycles/:workCycleId/edit",
        component: WorkCycleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCycle),
        },
    },
    {
        path: "work-cycles/:workCycleId",
        component: WorkCycleDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCycle),
        },
    },
    {
        path: "work-cycles",
        component: WorkCycleComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.WORK-CYCLE',
                order: 4,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCycle),
        },
    },
    {
        path: "rest-configurations/new",
        component: RestConfigurationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.restConfiguration),
        },
    },
    {
        path: "rest-configurations/:restConfigurationId/edit",
        component: RestConfigurationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.restConfiguration),
        },
    },
    {
        path: "rest-configurations/:restConfigurationId",
        component: RestConfigurationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.restConfiguration),
        },
    },
    {
        path: "rest-configurations",
        component: RestConfigurationComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.REST-CONFIGURATIONS',
                order: 5,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.restConfiguration),
        },
    },
    {
        path: "zones/new",
        component: ZoneDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.zone),
        },
    },
    {
        path: "zones/:zoneId/edit",
        component: ZoneDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.zone),
        },
    },
    {
        path: "zones/:zoneId",
        component: ZoneDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.zone),
        },
    },
    {
        path: "zones",
        component: ZoneComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ZONES',
                order: 6,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.zone),
        },
    },
    {
        path: "work-centers/new",
        component: WorkCenterDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCenter),
        },
    },
    {
        path: "work-centers/:workCenterId/edit",
        component: WorkCenterDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCenter),
        },
    },
    {
        path: "work-centers/:workCenterId",
        component: WorkCenterDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCenter),
        },
    },
    {
        path: "work-centers",
        component: WorkCenterComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.WORK-CENTERS',
                order: 7,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.workCenter),
        },
    },
    {
        path: "mobile-logs/:mobileLogId",
        component: MobileLogDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.mobileLog),
        },
    },
    {
        path: "mobile-logs",
        component: MobileLogComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.MOBILE-LOGS',
                order: 8,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.mobileLog),
        },
    },
    {
        path: "system-logs/:logId",
        component: SystemLogDetailComponent,
        data: {
            auth: { resource: MODULE_RESOURCES.attendance.systemLog, action: 'read' },
        },
    },
    {
        path: "system-logs",
        component: SystemLogComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.SYSTEM-LOGS',
                order: 8.25,
            },
            auth: { resource: MODULE_RESOURCES.attendance.systemLog, action: 'read' },
        },
    },
    {
        path: "overtimes/:overtimeId",
        component: OvertimeDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.overtime),
        },
    },
    {
        path: "overtimes",
        component: OvertimeComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.OVERTIMES',
                order: 8.5,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.overtime),
        },
    },
    {
        path: "attendance-events/new",
        component: AttendanceEventDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.event),
        },
    },
    {
        path: "attendance-events/:attendanceEventId",
        component: AttendanceEventDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.event),
        },
    },
    {
        path: "attendance-events",
        component: AttendanceEventComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ATTENDANCE-EVENTS',
                order: 9,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.event),
        },
    },
    {
        path: "facial-evidences",
        component: FacialEvidenceComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.FACIAL-EVIDENCES',
                icon: 'face_retouching_natural',
                order: 9.5,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.event),
        },
    },
    {
        path: "attendance-attempts/new",
        component: AttendanceAttemptDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attempt),
        },
    },
    {
        path: "attendance-attempts/:attendanceAttemptId",
        component: AttendanceAttemptDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attempt),
        },
    },
    {
        path: "attendance-attempts",
        component: AttendanceAttemptComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ATTENDANCE-ATTEMPTS',
                order: 10,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attempt),
        },
    },
    {
        path: "attendance-results/:attendanceResultId",
        component: AttendanceResultDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "attendance-results",
        component: AttendanceResultComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ATTENDANCE-RESULTS',
                order: 11,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "absences",
        component: AbsenceComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ABSENCES',
                order: 11.5,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "delays",
        component: DelayComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.DELAYS',
                order: 11.6,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "early-exits",
        component: EarlyExitComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.EARLY-EXITS',
                order: 11.7,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "missing-punches",
        component: MissingPunchComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.MISSING-PUNCHES',
                order: 11.8,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceResult),
        },
    },
    {
        path: "attendance-justification-types/new",
        component: AttendanceJustificationTypeDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustificationType),
        },
    },
    {
        path: "attendance-justification-types/:attendanceJustificationTypeId/edit",
        component: AttendanceJustificationTypeDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustificationType),
        },
    },
    {
        path: "attendance-justification-types/:attendanceJustificationTypeId",
        component: AttendanceJustificationTypeDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustificationType),
        },
    },
    {
        path: "attendance-justification-types",
        component: AttendanceJustificationTypeComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ATTENDANCE-JUSTIFICATION-TYPES',
                order: 12,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustificationType),
        },
    },
    {
        path: "attendance-justifications/new",
        component: AttendanceJustificationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustification),
        },
    },
    {
        path: "attendance-justifications/:attendanceJustificationId/edit",
        component: AttendanceJustificationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustification),
        },
    },
    {
        path: "attendance-justifications/:attendanceJustificationId",
        component: AttendanceJustificationDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustification),
        },
    },
    {
        path: "attendance-justifications",
        component: AttendanceJustificationComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.ATTENDANCE-JUSTIFICATIONS',
                order: 13,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.attendanceJustification),
        },
    },
    {
        path: "tracking-points/new",
        component: TrackingPointDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.trackingPoint),
        },
    },
    {
        path: "tracking-points/:trackingPointId/edit",
        component: TrackingPointDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.trackingPoint),
        },
    },
    {
        path: "tracking-points/:trackingPointId",
        component: TrackingPointDetailComponent,
        data: {
            auth: moduleAccess(MODULE_RESOURCES.attendance.trackingPoint),
        },
    },
    {
        path: "tracking-points",
        component: TrackingPointComponent,
        data: {
            nav: {
                title: 'MENUITEMS.ATTENDANCE.LIST.TRACKING-POINTS',
                order: 14,
            },
            auth: moduleAccess(MODULE_RESOURCES.attendance.trackingPoint),
        },
    },
    { path: "**", component: Page404Component },
];
